import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://www.trendmarksolutions.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Get token
export function getToken() {
  return localStorage.getItem("token");
}

// Attach token automatically
api.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ FIXED
export function saveAuth(auth) {
  if (!auth) return;

  const token = auth.token;
  const user = auth.user;

  if (token) {
    localStorage.setItem("token", token);
  }

  if (user) {
    localStorage.setItem("user", JSON.stringify(user));
  }
}

export function getStoredUser() {
  const raw = localStorage.getItem("user");

  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearAuth() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
}

export const getWatchlist = () => api.get("/watchlist");

export const searchStocks = (q) =>
  api.get(`/stocks/search?q=${encodeURIComponent(q)}`);

export const addWatchlist = (symbol, name) =>
  api.post("/watchlist/add", { symbol, name });

export const removeWatchlist = (symbol) =>
  api.delete(`/watchlist/${symbol}`);

// Exports
export { api };
export default api;